import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateUserPasswordInDb } from '../services/authService';

export default function ResetPassword() {
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);
    const navigate = useNavigate();

    // Supabase puts the token in the URL hash — this picks it up automatically
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (password !== confirm) { setError('Passwords do not match.'); return; }
        if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
        setLoading(true);
        setError('');
        try {
            await updateUserPasswordInDb(password);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to update password');
            setLoading(false);
            return;
        }
        setLoading(false);
        setDone(true);
        setTimeout(() => navigate('/login'), 3000);
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-stone-50">
            <div className="w-full max-w-sm rounded-2xl border border-stone-200 bg-white p-8 shadow-sm">
                <h1 className="text-xl font-semibold text-stone-900 mb-1">Set a new password</h1>
                <p className="text-sm text-stone-500 mb-6">Enter and confirm your new password below.</p>

                {done ? (
                    <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-700 text-center">
                        Password updated successfully. Redirecting to login...
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-stone-700 mb-1">New password</label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                className="block w-full rounded-lg border border-stone-300 px-3 py-2.5 text-sm focus:border-[#ee2b74] focus:outline-none focus:ring-2 focus:ring-[#ee2b74]/20"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-stone-700 mb-1">Confirm password</label>
                            <input
                                type="password"
                                required
                                value={confirm}
                                onChange={e => setConfirm(e.target.value)}
                                className="block w-full rounded-lg border border-stone-300 px-3 py-2.5 text-sm focus:border-[#ee2b74] focus:outline-none focus:ring-2 focus:ring-[#ee2b74]/20"
                            />
                        </div>
                        {error && <p className="text-sm text-red-600">{error}</p>}
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full rounded-lg bg-[#ee2b74] py-2.5 text-sm font-semibold text-white hover:bg-[#d4225f] disabled:opacity-60"
                        >
                            {loading ? 'Updating...' : 'Update password'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}